namespace MACRAIL.Validation {

export class NumberValidator implements IValidator {

    private opts: any;

    constructor (opts: any) {
        this.opts = opts;
    }

    public validate(value: any) {
        let opts = this.opts;

        let messages: IValidatorMessage[] = [];

        if (typeof value !== 'number' && !('' + value).match(/\d+/) &&
        (opts.optional === undefined || opts.optional === false)) {
            messages.push({
                'slug': 'number',
                'status': 'error',
                'message': opts.invalidMessage || `Enter a number`,
            });
        }

        let num = parseInt(value, 10);

        if (opts.minError && num < opts.minError) {
            messages.push({
                'slug': 'number',
                'status': 'error',
                'message': opts.errorMessage || `Must be at least ${opts.minError}.`,
            });
        } else if (opts.minWarning && num < opts.minWarning) {
            messages.push({
                'slug': 'number',
                'status': 'warning',
                'message': opts.warningMessage || `Should be at least ${opts.minWarning}.`,
            });
        }

        if (opts.maxError && num > opts.maxError) {
            messages.push({
                'slug': 'number',
                'status': 'error',
                'message': opts.errorMessage || `Must be ${opts.maxError} or less.`,
            });
        } else if (opts.maxWarning && num > opts.maxWarning) {
            messages.push({
                'slug': 'number',
                'status': 'warning',
                'message': opts.warningMessage || `Should be ${opts.maxWarning} or less.`,
            });
        }

        return messages;
    }
}

}
